import React, { FC, useMemo } from 'react';

import { ESpecialOfferInternalViewModel } from 'constants/enums';

import {
  FormFieldsGradientRow,
  FormFieldsIdentitySection,
  FormFieldsSection,
  FormFieldsTitleStyleSection,
  FormFieldsUploadSection
} from '../components';
import { TextFieldConfig } from '../FormFields.types';

import {
  BG_COLOR_FIELDS,
  FONT_WEIGHT_OPTIONS,
  TITLE_DEFAULTS,
  UPLOAD_FIELDS
} from './PromotionFormFields.consts';

interface IPromotionFormFieldsProps {
  shouldDisplaySubTitle?: boolean;
  specialOffersInternalViewModel?: ESpecialOfferInternalViewModel;
}

export const PromotionFormFields: FC<IPromotionFormFieldsProps> = ({
  shouldDisplaySubTitle = false,
  specialOffersInternalViewModel
}): React.ReactElement => {
  const maxCollectTextLength =
    specialOffersInternalViewModel === ESpecialOfferInternalViewModel.SPIN_X ||
    specialOffersInternalViewModel === ESpecialOfferInternalViewModel.CASH_FRENZY
      ? 25
      : 8;

  const collectTextField: TextFieldConfig = useMemo(() => ({
    label: 'Free Offer Text',
    name: 'collectText',
    placeholder: 'Collect',
    maxLength: maxCollectTextLength
  }), [maxCollectTextLength]);

  return (
    <React.Fragment>
      <FormFieldsSection heading="Promotion">
        <FormFieldsIdentitySection
          extraFields={[collectTextField]}
        />
      </FormFieldsSection>

      <FormFieldsSection
        heading="Promotion Design"
        description="Customize the promotion to fit your store theme."
        showSeparator
      >
        {/* TODO: Aligned with Jonathan — replace AcGradientInput (MUI) with new component when available */}
        <FormFieldsGradientRow fields={BG_COLOR_FIELDS} layout="half" />
        <FormFieldsUploadSection fields={UPLOAD_FIELDS} />
      </FormFieldsSection>

      <FormFieldsTitleStyleSection
        heading="Title"
        nameField="title"
        colorField="fontColor"
        sizeField="fontSize"
        weightField="fontWeight"
        fontWeightOptions={FONT_WEIGHT_OPTIONS}
        defaults={TITLE_DEFAULTS}
      />

      {shouldDisplaySubTitle && (
        <div className="pb-4">
          <FormFieldsTitleStyleSection
            heading="Subtitle"
            nameField="subTitleText"
            nameLabel="Subtitle Text"
            colorField="subTitleFontColor"
            sizeField="subTitleFontSize"
            weightField="subTitleFontWeight"
            fontWeightOptions={FONT_WEIGHT_OPTIONS}
            defaults={TITLE_DEFAULTS}
            sizeRange={{ min: 8, max: 16 }}
          />
        </div>
      )}
    </React.Fragment>
  );
};
